import { useNavigate } from 'react-router-dom';
import { getRecentArticles } from '@/mocks/articles';

export default function SeoContent() {
  const navigate = useNavigate();
  const recentArticles = getRecentArticles(10);
  const extraArticles = recentArticles.slice(1);

  return (
    <>
      {/* What Is Vigorbuy Spreadsheet */}
      <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
        <div className="max-w-4xl mx-auto">
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-14 items-center">
            <div className="lg:w-1/2">
              <div className="w-full h-[280px] md:h-[340px] rounded-xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Clean%20minimal%20workspace%20with%20laptop%20showing%20organized%20fashion%20product%20spreadsheet%20with%20colorful%20category%20tags%2C%20surrounded%20by%20fabric%20swatches%20and%20style%20moodboard%20on%20cork%20wall%2C%20warm%20natural%20daylight%20from%20large%20window%2C%20modern%20creative%20studio%20with%20plants%20and%20ceramic%20coffee%20mug%2C%20editorial%20productivity%20lifestyle%20photography&width=900&height=700&seq=what-is-v2-Q4p7&orientation=landscape&nocache=true"
                  alt="Vigorbuy Spreadsheet organized product research workspace"
                  title="What Is Vigorbuy Spreadsheet - Product Research Tool"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
            <div className="lg:w-1/2">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-4">
                What Is Vigorbuy Spreadsheet?
              </h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                <strong>Vigorbuy Spreadsheet</strong> is a structured product discovery resource that helps users organize products, compare categories, and find useful shopping information efficiently. Instead of spending hours searching manually, users can explore organized collections, category recommendations, and detailed buying guides — all consolidated into one accessible format.
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                The core advantage of using a Vigorbuy Spreadsheet is the organized approach to product research. Categories like <strong>Shoes</strong>, <strong>Hoodies</strong>, <strong>T-Shirts</strong>, and <strong>Accessories</strong> are systematically arranged, making it simple to browse, compare quality control photos, and evaluate pricing before making any purchasing decisions.
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                Whether you are new to online shopping or an experienced buyer looking for a more efficient way to discover products, the Vigorbuy Spreadsheet system provides the structure and clarity needed to make confident, informed choices.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose - Comparison with images */}
      <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
              Why Thousands Of Users Prefer Vigorbuy Spreadsheet
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
              See how structured product research compares to traditional browsing methods
            </p>
          </div>

          <div className="flex flex-col lg:flex-row gap-6 mb-10">
            <div className="lg:w-1/2 bg-background-100 rounded-xl overflow-hidden border border-background-200 p-5">
              <div className="w-full h-[180px] rounded-lg overflow-hidden mb-4">
                <img
                  src="https://readdy.ai/api/search-image?query=Cluttered%20chaotic%20workspace%20with%20multiple%20browser%20tabs%20open%20showing%20scattered%20product%20pages%2C%20messy%20desk%20with%20sticky%20notes%20and%20stressed%20expression%2C%20overwhelming%20disorganized%20online%20shopping%20scene%2C%20warm%20but%20chaotic%20lighting%2C%20realistic%20unfiltered%20editorial%20style&width=800&height=500&seq=comparison-traditional-R5s9&orientation=landscape&nocache=true"
                  alt="Traditional online shopping - scattered and time consuming"
                  title="Traditional Shopping vs Vigorbuy Spreadsheet"
                  className="w-full h-full object-cover"
                />
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-800 mb-2">Traditional Shopping</h3>
              <p className="text-sm text-foreground-500">Scattered tabs, hours of searching, limited comparison ability</p>
            </div>
            <div className="lg:w-1/2 bg-primary-50 rounded-xl overflow-hidden border border-primary-200 p-5">
              <div className="w-full h-[180px] rounded-lg overflow-hidden mb-4">
                <img
                  src="https://readdy.ai/api/search-image?query=Organized%20clean%20workspace%20with%20single%20laptop%20displaying%20neat%20categorized%20spreadsheet%20with%20product%20images%20and%20ratings%2C%20calm%20productive%20atmosphere%2C%20minimal%20desk%20with%20small%20plant%20and%20notebook%2C%20bright%20natural%20light%2C%20serene%20efficient%20editorial%20photography&width=800&height=500&seq=comparison-spreadsheet-T6u1&orientation=landscape&nocache=true"
                  alt="Vigorbuy Spreadsheet - organized and efficient product discovery"
                  title="Vigorbuy Spreadsheet - Efficient Shopping"
                  className="w-full h-full object-cover"
                />
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-800 mb-2">Vigorbuy Spreadsheet</h3>
              <p className="text-sm text-primary-600">Organized categories, minutes to browse, everything in one place</p>
            </div>
          </div>

          <div className="bg-background-100 rounded-xl overflow-hidden border border-background-200">
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead>
                  <tr className="border-b border-background-200">
                    <th className="text-left px-5 py-4 text-sm font-semibold text-foreground-800 whitespace-nowrap">Feature</th>
                    <th className="text-left px-5 py-4 text-sm font-semibold text-foreground-500 whitespace-nowrap">Normal Search</th>
                    <th className="text-left px-5 py-4 text-sm font-semibold text-primary-600 whitespace-nowrap">Vigorbuy Spreadsheet</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b border-background-200">
                    <td className="px-5 py-3.5 text-sm text-foreground-700 font-medium whitespace-nowrap">Product Discovery</td>
                    <td className="px-5 py-3.5 text-sm text-foreground-500">Slow — manual browsing</td>
                    <td className="px-5 py-3.5 text-sm text-primary-600 font-medium">Organized — one place</td>
                  </tr>
                  <tr className="border-b border-background-200">
                    <td className="px-5 py-3.5 text-sm text-foreground-700 font-medium whitespace-nowrap">Product Filtering</td>
                    <td className="px-5 py-3.5 text-sm text-foreground-500">Limited options</td>
                    <td className="px-5 py-3.5 text-sm text-primary-600 font-medium">Category-based clarity</td>
                  </tr>
                  <tr className="border-b border-background-200">
                    <td className="px-5 py-3.5 text-sm text-foreground-700 font-medium whitespace-nowrap">Research Time</td>
                    <td className="px-5 py-3.5 text-sm text-foreground-500">Hours of searching</td>
                    <td className="px-5 py-3.5 text-sm text-primary-600 font-medium">Minutes — streamlined</td>
                  </tr>
                  <tr className="border-b border-background-200">
                    <td className="px-5 py-3.5 text-sm text-foreground-700 font-medium whitespace-nowrap">QC Checking</td>
                    <td className="px-5 py-3.5 text-sm text-foreground-500">Difficult to verify</td>
                    <td className="px-5 py-3.5 text-sm text-primary-600 font-medium">Integrated QC photos</td>
                  </tr>
                  <tr>
                    <td className="px-5 py-3.5 text-sm text-foreground-700 font-medium whitespace-nowrap">Beginner Experience</td>
                    <td className="px-5 py-3.5 text-sm text-foreground-500">Complex and scattered</td>
                    <td className="px-5 py-3.5 text-sm text-primary-600 font-medium">Simple and intuitive</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>

      {/* Safety Section */}
      <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
        <div className="max-w-4xl mx-auto">
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-14 items-center">
            <div className="lg:w-1/2 order-2 lg:order-1">
              <div className="inline-flex items-center justify-center w-14 h-14 md:w-16 md:h-16 rounded-full bg-secondary-100 mb-5">
                <i className="ri-shield-check-line text-2xl text-secondary-600 flex items-center justify-center"></i>
              </div>
              <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-4">
                Is Vigorbuy Spreadsheet Safe?
              </h2>
              <p className="text-sm md:text-base text-foreground-500 max-w-2xl mb-8 leading-relaxed">
                The Vigorbuy Spreadsheet is an informational resource designed to help you discover and research products efficiently. We encourage all users to verify product sources, protect personal information, and understand product risks before making purchasing decisions. The spreadsheet provides organized data — smart shopping practices are always your responsibility.
              </p>
              <div className="flex flex-wrap gap-3">
                <button
                  onClick={() => navigate('/article/vigorbuy-spreadsheet-safety-guide')}
                  className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-secondary-500 text-background-50 text-sm font-semibold hover:bg-secondary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                >
                  Read Safety Guide
                  <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
                </button>
                <button
                  onClick={() => navigate('/article/vigorbuy-spreadsheet-qc-photos-guide')}
                  className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-background-100 text-foreground-700 text-sm font-medium hover:bg-background-200 transition-colors duration-200 cursor-pointer whitespace-nowrap border border-background-200"
                >
                  QC Photos Guide
                  <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
                </button>
              </div>
            </div>
            <div className="lg:w-1/2 order-1 lg:order-2">
              <div className="w-full h-[260px] md:h-[320px] rounded-xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20cybersecurity%20shield%20hologram%20floating%20above%20smartphone%20on%20clean%20desk%2C%20soft%20natural%20window%20lighting%20with%20warm%20beige%20walls%2C%20small%20potted%20succulent%20and%20notebook%20nearby%2C%20professional%20yet%20approachable%20online%20safety%20concept%2C%20data%20protection%20and%20secure%20shopping%20editorial%20photography&width=900&height=700&seq=safety-v2-U7v2&orientation=landscape&nocache=true"
                  alt="Vigorbuy Spreadsheet safety and security guide"
                  title="Is Vigorbuy Spreadsheet Safe - Security Guide"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Main Article Preview */}
      <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
              Featured Guide
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
              {recentArticles[0].title}
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto mb-8">
              {recentArticles[0].excerpt}
            </p>
          </div>

          <div className="bg-background-100 rounded-xl border border-background-200 overflow-hidden">
            <div className="w-full h-[200px] md:h-[260px] overflow-hidden">
              <img
                src={recentArticles[0].heroImageUrl}
                alt={recentArticles[0].title}
                title={recentArticles[0].title}
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="p-5 md:p-7">
              <div className="flex items-center gap-3 text-xs text-foreground-400 mb-3">
                <span>{recentArticles[0].publishedDate}</span>
                <span>·</span>
                <span>{recentArticles[0].readTime}</span>
                <span>·</span>
                <span>{recentArticles[0].category}</span>
              </div>
              <button
                onClick={() => navigate(`/article/${recentArticles[0].slug}`)}
                className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
              >
                Read Full Guide
                <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* 9 More Article Previews */}
      <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3">
              More SEO Guides
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
              Explore More Vigorbuy Spreadsheet Guides
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
              Dive deeper with our collection of expert-written guides covering safety, categories, tutorials, and shopping strategies
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
            {extraArticles.map((article) => (
              <button
                key={article.slug}
                onClick={() => {
                  window.scrollTo(0, 0);
                  navigate(`/article/${article.slug}`);
                }}
                className="group bg-background-50 rounded-xl border border-background-200 overflow-hidden hover:border-primary-300 transition-all duration-300 cursor-pointer text-left w-full"
              >
                <div className="w-full h-[160px] md:h-[180px] overflow-hidden">
                  <img
                    src={article.heroImageUrl}
                    alt={article.title}
                    title={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-4 md:p-5">
                  <span className="text-xs text-primary-500 font-medium">{article.category}</span>
                  <h3 className="text-sm md:text-base font-semibold text-foreground-800 mt-1.5 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug">
                    {article.title}
                  </h3>
                  <p className="text-xs text-foreground-400 mt-2 line-clamp-2 leading-relaxed">
                    {article.excerpt}
                  </p>
                  <div className="flex items-center gap-3 mt-3 text-xs text-foreground-400">
                    <span>{article.readTime}</span>
                    <span className="flex items-center gap-1 text-primary-500 font-medium">
                      Read More
                      <i className="ri-arrow-right-line w-3 h-3 flex items-center justify-center"></i>
                    </span>
                  </div>
                </div>
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Disclaimer */}
      <section className="w-full px-4 md:px-6 py-10 bg-background-100 border-t border-background-200">
        <div className="max-w-3xl mx-auto text-center">
          <p className="text-xs md:text-sm text-foreground-400 leading-relaxed">
            <strong>Disclaimer:</strong> We are an independent informational platform providing educational resources, product guides, comparisons and shopping information related to Vigorbuy Spreadsheet. This website is NOT the official Vigorbuy website and is not affiliated with any specific brand. All product links direct to third-party websites. Always conduct your own research before making purchasing decisions.
          </p>
        </div>
      </section>
    </>
  );
}